export default __webpack_public_path__ + "static/Recoleta-Bold-36c010e7950f830ad83513d12f117427.woff";